import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import SaveMailboxSelectionFormContainer from '../containers/SaveMailboxSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class SaveMailboxSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    this.props.saveSelection({
      name,
      checkedMailboxes: this.props.checkedMailboxes,
    });
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.save.mailbox.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <SaveMailboxSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          checkedMailboxes={this.props.checkedMailboxes}
        />
      </Modal>
    );
  }
}

SaveMailboxSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    ediMailboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedMailboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default (SaveMailboxSelectionModal);
